function cov_2pxkz9a1h6() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/index.ts";
  var hash = "b5057aa51be11afae4c179410536e14808fe63bd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 28
        },
        end: {
          line: 28,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b5057aa51be11afae4c179410536e14808fe63bd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pxkz9a1h6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2pxkz9a1h6();
import { breakpoints, colors, fontSizesNamedWithUnits, fontWeights, radii, shadows, space, fonts, lineHeightsWithUnits } from './foundations';
export * from './foundations';
import { numbersArrWithUnits } from '../helpers';
import { components } from './components';
export var eero = (cov_2pxkz9a1h6().s[0]++, {
  breakpoints: numbersArrWithUnits(breakpoints),
  colors: colors,
  fonts: fonts,
  fontSizes: fontSizesNamedWithUnits,
  fontWeights: fontWeights,
  lineHeights: lineHeightsWithUnits,
  radii: radii,
  shadows: shadows,
  space: numbersArrWithUnits(space),
  components: components
});